import React, { useState, useEffect } from "react";
import Loading from "react-loading";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { uploadFileToIPFS, uploadJSONToIPFS } from "../pinata";
import DocMinter from "../DocMinter.json";
import connectWallet from "../interact/connectWallet";
import connectedWallets from "../interact/connectedWallets";
import Uploading from "../Uploading";

function Mint() {
  const ethers = require("ethers");
  const current = new Date();
  const currentDate = `${current.getDate()}/${
    current.getMonth() + 1
  }/${current.getFullYear()} ${current.getHours()}:${current.getMinutes()}:${current.getSeconds()}`;
  console.log(currentDate);

  // variables that will change depending on inputs or events
  const [name, setName] = useState("");
  const [CIN, setCIN] = useState("");
  const [gender, setGender] = useState("");
  const [date, setDate] = useState(currentDate);
  const [fileURL, setFileURL] = useState("");
  const [numberOfFilesMinted, setNumberOfFileMinted] = useState(0);
  const [address, setAddress] = useState("");
  const [status, setStatus] = useState("");
  const [uploading, setUploading] = useState();
  const [fileStatus, setFileStatus] = useState();
  const [idOfFile, setIdOfFile] = useState();

  // varibales related to uploading and minting phases
  const [isUploadingFile, setIsUploadingFile] = useState(false);
  const [connectButton, setConnectButton] = useState(false);
  const [minted, setMinted] = useState(false);

  // This function uploads file to IPFS
  async function uploadFileToIpfs(e) {
    setIsUploadingFile(true);
    var file = e.target.files[0];
    //check for file extension
    setUploading(false);
    try {
      //upload the file to IPFS
      const response = await uploadFileToIPFS(file);
      if (response.success === true) {
        setFileURL(response.pinataURL);
        console.log("File uploaded successfully to IPFS ", response.pinataURL);
        setUploading(true);
        toast(
          "File content uploaded to IPFS! Please click on the mint button",
          { type: "success" }
        );
      }
    } catch (error) {
      console.log("Error during file upload", error);
    }
    setIsUploadingFile(false);
  }

  // This function uploads the metadata to IPFS

  async function uploadMetadataToIpfs() {
    let fileMetadata = {
      fileName: "",
      fileUrl: "",
      CIN: "",
      gender: "",
      date: "",
    };
    // make sure that none of the fields are empty
    if (!name || !fileURL || !CIN || !gender || !date) return;
    fileMetadata.fileName = name;
    fileMetadata.fileUrl = fileURL;
    fileMetadata.CIN = CIN;
    fileMetadata.gender = gender;
    fileMetadata.date = date;

    try {
      // upload metadata to IPFS
      const response = await uploadJSONToIPFS(fileMetadata);
      if (response.success === true) {
        console.log("Uploaded JSON to Pinata: ", response);
        toast("File metadata uploaded successfully to IPFS!", {
          type: "success",
        });
        return response.pinataURL;
      }
    } catch (error) {
      console.log("error uploading JSON metadata:", error);
    }
  }

  async function filesMinted() {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();

    //Pull the deployed contract instance
    let contract = new ethers.Contract(
      DocMinter.address,
      DocMinter.abi,
      signer
    );
    let call = await contract.getMyNfts();
    console.log(call.length);
    setNumberOfFileMinted(call.length);
  }

  async function mintDocument(e) {
    e.preventDefault();
    setFileStatus(false);
    setMinted(true);

    //Upload data to IPFS
    try {
      const metadataURL = await uploadMetadataToIpfs();

      // an3ayto l contract dialna
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();

      //Pull the deployed contract instance
      let contract = new ethers.Contract(
        DocMinter.address,
        DocMinter.abi,
        signer
      );

      // create the NFT
      let transaction = await contract.createToken(
        metadataURL,
        name,
        CIN,
        fileURL,
        gender,
        date
      );
      await transaction.wait();
      console.log(transaction);
      let fileId = await contract.getTokenId();

      let FileId = fileId.toString();
      console.log("File minted successfully to the blockchain!");
      toast("Congrats! File minted successfully!", { type: "success" });
      console.log(fileId.toString());
      setFileStatus(true);
      setIdOfFile(FileId);
      filesMinted();
    } catch (error) {
      alert("Upload error" + error);
    }
    setMinted(false);
  }

  /* We can display variables by declaring them before the return keyword and call them with curly braces {} */
  const projectName = "Welcome to the official document minter dApp";

  function handleName(e) {
    console.log(e.target.value);
    setName(e.target.value);
  }

  function handleCIN(e) {
    console.log(e.target.value);
    setCIN(e.target.value);
  }

  function handleGender(e) {
    console.log(e.target.value);
    setGender(e.target.value);
  }

  async function connectWalletPressed() {
    setConnectButton(true);
    const response = await connectWallet();
    setAddress(response.address);
    setStatus(response.status);
    setConnectButton(false);
    if (response.address.length > 0) {
      toast("Connected successfully!", { type: "success" });
      filesMinted();
    } else {
      toast("Please install Metamask!", { type: "warning" });
    }
  }

  function walletListener() {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", (accounts) => {
        if (accounts.length > 0) {
          setAddress(accounts[0]);
          filesMinted();
        } else {
          setAddress("");
        }
      });
    } else {
      return <div>Install metamask</div>;
    }
  }

  useEffect(() => {
    async function fetchData() {
      const response = await connectedWallets();
      setAddress(response);
    }

    fetchData();
    walletListener();
    filesMinted();
  }, []);

  return (
    <div className="mintPage">
      <div className="mint_page_content">
        <ToastContainer />
        <div>{uploading && <Uploading />}</div>
        {isUploadingFile && (
          <div className="loading-modal">
            <Loading type="spin" color="black" height={50} width={50} />
          </div>
        )}

        <div>
          {uploading && (
            <a href={fileURL} target="_blank" rel="noreferrer">
              Visit the file
            </a>
          )}
        </div>
        <div>
          {minted && (
            <div className="loading-modal">
              <Loading type="spin" color="black" height={50} width={50} />
            </div>
          )}
          {fileStatus && (
            <span>
              Congrats! You have minted your file to the blockchain:
              <br />
              Id of the file :{" "}
              <span className="transactionDetails">
                {idOfFile}{" "}
                <span className="italic">Please save this file Id</span>
              </span>
            </span>
          )}
        </div>
        <button className="connectWallet" onClick={connectWalletPressed}>
          {address.length > 0 ? (
            "Connected: " +
            String(address).substring(0, 6) +
            "..." +
            String(address).substring(38)
          ) : (
            <span className="beforeConnecting">Connect wallet</span>
          )}
        </button>
        <span>
          {address.length > 0 && (
            <span>
              Number of files minted by this wallet : {numberOfFilesMinted}
            </span>
          )}
        </span>
        {connectButton && (
          <div className="loading-modal">
            <Loading type="spin" color="black" height={20} width={20} />
          </div>
        )}
        <span className="status">{status}</span>

        <h1 className="projectName">{projectName}</h1>
        <div>
          <form>
            <label htmlFor="type">Document type</label>
            <select id="type" name="type" onChange={handleName} required>
              <option value="Choose your document type">
                Choose your document type
              </option>
              <option value="Birth certificate">Birth certificate</option>
              <option value="Certificate of Ownership">
                Certificate of Ownership
              </option>
              <option value="Diplome">Diplome</option>
              <option value="Driver license">Driver license</option>
            </select>

            <label htmlFor="fname">Numero CIN</label>
            <input
              type="text"
              id="fname"
              name="CIN"
              placeholder="Enter CIN..."
              onChange={handleCIN}
              required
            />
            <label htmlFor="gender">Gender</label>
            <select id="gender" name="gender" onChange={handleGender} required>
              <option value="Choose your gender">Choose your gender</option>
              <option value="Female">Female</option>
              <option value="Male">Male</option>
            </select>

            <span>Date : {currentDate} </span>

            <label htmlFor="files" className="drop-container">
              <span className="drop-title">Drop file here</span>
              or
              <input
                id="files"
                type={"file"}
                className="fileToIpfs"
                onChange={uploadFileToIpfs}
                required
              />
            </label>

            {/* <label htmlFor="metadata">Upload metadata</label>
            <input
              type="button"
              value="to ipfs"
              onClick={uploadMetadataToIpfs}
            /> */}
            <label>
              <input
                className="mintnft"
                type="button"
                value="Mint document"
                onClick={mintDocument}
              />
            </label>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Mint;
